export const UserIcon = (props) => (
  <svg
    width={props.width ? props.width : "1em"}
    height={props.height ? props.height : "1em"}
    viewBox="0 0 472 472"
    fill="currentColor"
    role="img"
    aria-label="User"
    {...props}
  >
    <path d="M403 69a235 235 0 0 0-334 0 235 235 0 0 0 0 334 235 235 0 0 0 334 0 235 235 0 0 0 0-334ZM118 412a122 122 0 0 1 237 0 211 211 0 0 1-237 0Zm41-197a77 77 0 1 1 155 0 77 77 0 0 1-155 0Zm216 181c-14-43-48-77-91-92a101 101 0 1 0-96 0c-43 15-77 49-91 92a212 212 0 1 1 278 0Z" />
  </svg>
);

// This asset has been put through SVGO with reduced precision.
// If for some reason we need the original, this is the original path command:
// d="m403.02,69.15C358.43,24.56,299.14,0,236.08,0S113.74,24.56,69.15,69.15,0,173.02,0,236.08s24.56,122.35,69.15,166.94c44.59,44.59,103.88,69.15,166.94,69.15s122.35-24.56,166.94-69.15c44.59-44.59,69.15-103.88,69.15-166.94s-24.56-122.35-69.15-166.94ZM117.59,411.9c13.39-52.96,61.43-92.27,118.5-92.27s105.11,39.31,118.5,92.26c-33.86,22.89-74.65,36.27-118.5,36.27s-84.64-13.38-118.5-36.27Zm41.24-197.15c0-42.6,34.66-77.26,77.26-77.26s77.26,34.66,77.26,77.26-34.66,77.26-77.26,77.26-77.26-34.66-77.26-77.26Zm216.18,181.46c-14.21-43.12-47.97-77.44-90.74-92.41,31.59-17.16,53.08-50.64,53.08-89.04,0-55.83-45.42-101.26-101.26-101.26s-101.26,45.42-101.26,101.26c0,38.41,21.49,71.88,53.08,89.04-42.77,14.97-76.53,49.29-90.73,92.42-44.8-38.91-73.18-96.27-73.18-160.13C24,119.14,119.14,24,236.08,24s212.08,95.14,212.08,212.08c0,63.86-28.37,121.21-73.16,160.12Z"

export default UserIcon;
